<template>
  <v-footer height="auto">
    <v-container grid-list-md>
      <v-layout row wrap text-xs-center>
        <v-flex xs12 sm4 light class="mx-auto" color="#F5F5F5" width="300">
          <img
            class="responsive"
            src="https://i.ibb.co/CtDmWVH/LOGO-POLO-TELEMON-1.png"
          />
          <v-card-text style="color:#6D7373;" class="body-2 text-sm-left"
            >Subscribete a nuestro Web Channel y realiza tus transacciones
            auto-asistidas las 24 horas del día.</v-card-text
          >

          <v-card-text class=" font-weight-bold text-sm-left">
            <span style="color:#6D7373" class="subheading">Síguenos:</span>
            <v-btn text icon color="blue darken-4">
              <img src="https://img.icons8.com/color/32/000000/facebook.png" />
            </v-btn>
            <v-btn text icon color="#6D7373">
              <img
                src="https://cdn2.iconfinder.com/data/icons/social-icons-33/128/Instagram-24.png"
              />
            </v-btn>

            <v-btn text icon color="#6D7373">
              <img
                src="https://cdn2.iconfinder.com/data/icons/social-icons-33/128/Youtube-24.png"
              />
            </v-btn>
          </v-card-text>
        </v-flex>

        <v-flex xs12 sm4 class="mx-auto" color="#F5F5F5" light width="300">
          <v-card-text
            style="color:#424242;"
            class="title font-weight-medium text-sm-left"
            >ENLACES DE INTERÉS</v-card-text
          >
          <v-card-text style="color:#6D7373;" class="body-2 text-sm-left"
            >Consulta de Servicios</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text style="color:#6D7373;" class="body-2 text-sm-left"
            >Evalúe nuestro servicio</v-card-text
          >
          <v-divider></v-divider>

          <v-card-text style="color:#6D7373;" class="body-2 text-sm-left"
            >Políticas Garantías Equipos Telemon</v-card-text
          >
          <v-divider></v-divider>

          <v-card-text style="color:#6D7373;" class="body-2 text-sm-left"
            >Políticas de Cobros</v-card-text
          >
        </v-flex>

        <v-flex xs12 sm4 class="mx-auto" color="#F4F6F5" light width="300">
          <v-card-text class="title font-weight-medium text-sm-left"
            >CONTACTO</v-card-text
          >
          <v-card-text style="color:#6D7373;" class="body-2 text-sm-left"
            >Desde tu móvil:</v-card-text
          >
          <v-divider></v-divider>
          <v-card-text
            style="color:#6D7373;"
            class="title font-weight-bold text-sm-left"
          >
            <v-icon color="#6D7373">call</v-icon>(809)584-7676
          </v-card-text>
        
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-card-title dark>
        Copyright © 2021 Telemontv
      </v-card-title>
    </v-container>
  </v-footer>
</template>
<script>
export default {
  name: "Footer",
};
</script>
<style scoped>
.responsive {
  width: 100%;
  max-width: 300px;
  height: auto;
}
</style>
